import { Component, Input } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { CommunityModule } from '../../common/community/community.module';
import { CommonComponentsModule } from '../../common/components/common-components.module';
import { SharedModule } from '../../shared/shared.module';
import { EmojiHtmlPipe } from '../../pipes/emoji-html.pipe';

interface ArticleCardUser {
  slug: string;
  name: string;
  country?: { name: string };
  user_title?: string;
  [key: string]: unknown;
}

export interface ArticleCard {
  id: number;
  slug: string;
  title: string;
  published_at: string;
  user: ArticleCardUser;
  [key: string]: unknown;
}

@Component({
  selector: 'ut-article-card',
  standalone: true,
  imports: [UIRouterModule, CommunityModule, CommonComponentsModule, SharedModule, EmojiHtmlPipe],
  templateUrl: './article-card.component.html',
  styleUrl: './article-card.component.scss',
})
export class ArticleCardComponent {
  @Input({ required: true }) article!: ArticleCard;
}
